<template>
  <div id="home-page">
    <div class="card-list-box">
      <div class="card-item" v-for="(item, index) in cardList" :key="item.name" @click="handleClick(index)">
        <div class="item-icon"><img :src="`/static/img/home/${item.icon}.png`" alt=""></div>
        <div class="item-name">
          <p>{{item.value}}</p>
          <p>{{item.name}}</p>
        </div>
      </div>
    </div>
    <div class="query-time">
      <el-radio-group v-model="type" @change="handleChange">
        <el-radio label="0">近一月</el-radio>
        <el-radio label="1">近三月</el-radio>
        <el-radio label="2">近一年</el-radio>
      </el-radio-group>
    </div>
    <div class="chart-box">
      <div ref="chart1"></div>
      <div ref="chart2"></div>
      <div ref="chart3"></div>
      <div ref="chart4"></div>
    </div>
  </div>
</template>

<script>
import { OPTIONBAR, OPTIONPIE, getTopData, equipMaintainType, statisticsEquipMaintainNum, statisticsScrapNum, statisticsScrapType } from './service.js'

export default {
  name: 'HomePage',
  components: {
  },
  data () {
    return {
      cardList: [
        { name: '正常设备', icon: 'normal', value: 0, query: '0' },
        { name: '待保养', icon: 'toMaintain', value: 0, query: '1' },
        { name: '待报废', icon: 'toScrap', value: 0, query: '2' },
        { name: '已报废', icon: 'scraped', value: 0, query: '3' },
        { name: '报废逾期', icon: 'scraping', value: 0, query: '4' },
      ],
      type: '0',
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
    }
  },
  created () {
  },
  mounted () {
    this.renderChart()
    this.getTopData()

    this.getChartsData({ type: '0' })
  },
  methods: {
    initChart (chart, option) {
      let chartDom = this.$refs[chart]
      this[chart] = this.$echarts.init(chartDom)
      this[chart].setOption(option)

      window.addEventListener('resize', () => {
        this[chart].resize()
      })
    },
    // 渲染echart
    renderChart () {
      let chartArr = [
        { chart: 'chart1', title: '保养次数', option: JSON.parse(JSON.stringify(OPTIONBAR)) },
        { chart: 'chart2', title: '保养设备类型', option: JSON.parse(JSON.stringify(OPTIONPIE)) },
        { chart: 'chart3', title: '报废设备数量', option: JSON.parse(JSON.stringify(OPTIONBAR)) },
        { chart: 'chart4', title: '报废设备类型', option: JSON.parse(JSON.stringify(OPTIONPIE)) },
      ]
      chartArr.forEach(({ chart, option, title }) => {
        option.title.text = title + '统计'
        option.series[0].name = title
        this.initChart(chart, option)
      })
    },
    // 切换时间
    handleChange (e) {
      this.type = e
      this.getChartsData({ type: e })
    },
    // 跳转链接
    handleClick (index) {
      this.$router.push({ name: 'devicePage', params: { status: this.cardList[index].query } })
    },
    // 请求顶部四个类型的数据
    async getTopData () {
      let res = await getTopData()
      if (res.code === 'success') {
        res.data.list.forEach(({ num, status }) => {
          this.cardList[status].value = num
        })
      }
    },
    getChartsData (params) {
      this.statisticsEquipMaintainNum(params)
      this.equipMaintainType(params)
      this.statisticsScrapNum(params)
      this.statisticsScrapType(params)
    },
    // 请求chart数据-统计保养次数
    async statisticsEquipMaintainNum (params) {
      let unit = params.type === '0' ? '号' : '月'

      let res = await statisticsEquipMaintainNum(params)
      if (res.code === 'success') {
        let xAxis = []; let data = []
        for (const [key, value] of Object.entries(res.data)) {
          let { num, dayTime } = value
          xAxis.push(dayTime + unit)
          data.push(num)
        }

        this.setChartOption('bar', 'chart1', xAxis, data)
      }
    },
    // 请求chart数据-统计保养设备类型
    async equipMaintainType (params) {
      let res = await equipMaintainType(params)
      if (res.code === 'success') {
        let legend = []; let data = []
        for (const [key, value] of Object.entries(res.data)) {
          let { num, equipType } = value
          legend.push(equipType)
          data.push({ value: num, name: equipType })
        }

        this.setChartOption('pie', 'chart2', legend, data)
      }
    },
    // 请求chart数据-报废设备数量统计
    async statisticsScrapNum (params) {
      let unit = params.type === '0' ? '号' : '月'

      let res = await statisticsScrapNum(params)
      if (res.code === 'success') {
        let xAxis = []; let data = []
        for (const [key, value] of Object.entries(res.data)) {
          let { num, dayTime } = value
          xAxis.push(dayTime + unit)
          data.push(num)
        }

        this.setChartOption('bar', 'chart3', xAxis, data)
      }
    },
    // 请求chart数据-报废设备类型统计
    async statisticsScrapType (params) {
      let res = await statisticsScrapType(params)
      if (res.code === 'success') {
        let legend = []; let data = []
        for (const [key, value] of Object.entries(res.data)) {
          let { num, equipType } = value
          legend.push(equipType)
          data.push({ value: num, name: equipType })
        }

        this.setChartOption('pie', 'chart4', legend, data)
      }
    },
    setChartOption (type, chart, xAxis, data) {
      let option = this[chart].getOption()
      if (type === 'bar') {
        option.xAxis[0].data = xAxis
        option.series[0].data = data
        if (chart === 'chart3') {
          option.yAxis[0].name = '个'
        }
      } else {
        option.legend[0].data = xAxis
        option.series[0].data = data
      }
      this[chart].setOption(option)
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/static/style/common';

#home-page {
  padding: 15px 25px 0px;
  max-width: 1920px;
  .card-list-box {
    display: flex;
    justify-content: space-between;
    // border: 1px solid red;
    .card-item {
      width: 15%;
      height: 80px;
      background-color: #fff;
      display: inline-block;
      border-radius: 4px;
      padding: 20px 30px;
      cursor: pointer;
      .item-icon {
        display: inline-block;
        width: 40%;
        height: 70px;
        line-height: 87px;
        background-color: #f2f5ff;
        text-align: center;
      }
      .item-name {
        display: inline-block;
        width: 54%;
        vertical-align: -15px;
        margin-left: 5%;
        p {
          width: 100%;
          font-size: 14px;
          color: #999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:first-child {
            font-size: 25px;
            color: #3ba1ff;
            font-weight: bold;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
  .query-time {
    background-color: #fff;
    margin-top: 10px;
    line-height: 50px;
    padding-left: 30px;
    border-bottom: 1px solid #ccc;
  }
  .chart-box {
    >div {
      overflow: hidden;
      display: inline-block;
      width: 49.4%;
      height: 310px;
      background-color: #fff;
      margin-bottom: 20px;
      &:nth-child(even) {
        float: right;
      }
    }
  }
}
</style>
